
import { Vue, Component } from "vue-property-decorator";
import { sizeData } from "./sizeData";
import cloneDeep from "lodash/cloneDeep";
interface Option {
  label: string;
  value: number;
}
interface SizeTypeOption extends Option {
  valueOptions: SizeValueOption[];
}
interface SizeValueOption {
  label: string;
  value: string;
  checked?: boolean;
}
@Component
export default class sizePanel extends Vue {
  sizeTypeOptions: SizeTypeOption[] = [];
  sizeValueOptions: SizeValueOption[] = [];
  sizeType: number | null = null;
  checkedSizes: string[] = [];
  customSizeValue = "";
  created() {
    this.sizeTypeOptions = sizeData.map((ele) => ({
      label: ele.text,
      value: ele.type,
      valueOptions: ele.list.map((li: { text: string }) => ({
        label: li.text,
        value: li.text,
      })),
    }));
  }
  handleSizeTypeChange(value: number) {
    this.checkedSizes = this.checkedSizes.filter(
      (size) => !this.sizeValueOptions.some((opt) => opt.value === size)
    );
    this.sizeValueOptions = [];
    // this.emitChange();
    this.customSizeValue = "";
    const sizeTypeOption = this.sizeTypeOptions.find(
      (ele) => ele.value === value
    );
    if (sizeTypeOption) {
      this.sizeValueOptions = sizeTypeOption.valueOptions.map((opt) => ({
        ...opt,
        checked: false,
      }));
    }
  }
  handleSizeValueCheckedChange(sizeValue: SizeValueOption, checked: boolean) {
    if (checked) {
      this.addSizeValue(sizeValue.value);
      console.log("this.checkedSizes", this.checkedSizes);
    } else {
      this.checkedSizes = this.checkedSizes.filter(
        (ele) => ele !== sizeValue.value
      );
      this.emitChange();
    }
  }
  addCustomSizeValue(value: string) {
    if (!value) {
      return;
    }
    if (value.indexOf(",") >= 0) {
      this.$message.warning(`非法字符“,”`);
      return;
    }
    this.addSizeValue(value);
    this.$nextTick(() => {
      this.customSizeValue = "";
    });
  }
  addSizeValue(value: string) {
    if (value && this.checkedSizes.indexOf(value) === -1) {
      this.checkedSizes.push(value);
      this.emitChange();
    }
  }
  handleCustomSizeValueInputEnter() {
    this.addCustomSizeValue(this.customSizeValue);
  }
  removeSizeByCheckedIndex(index: number) {
    const value = this.checkedSizes[index];
    this.sizeValueOptions.forEach((opt) => {
      if (opt.value === value) {
        opt.checked = false;
      }
    });
    const matchOption = this.sizeValueOptions.find(
      (opt) => opt.value === value
    );
    if (matchOption) {
      matchOption.checked = false;
    }
    this.checkedSizes.splice(index, 1);
    this.emitChange();
  }
  removeSizeByValue(value: string) {
    const matchCheckedIndex = this.checkedSizes.findIndex(
      (size) => size === value
    );
    if (matchCheckedIndex !== -1) {
      this.removeSizeByCheckedIndex(matchCheckedIndex);
    }
  }
  setCheckedValues(values: string[]) {
    values.forEach((value) => {
      const matchOption = this.sizeValueOptions.find(
        (ele) => ele.value === value
      );
      if (matchOption && !matchOption.checked) {
        matchOption.checked = true;
        this.addSizeValue(value);
      } else if (!matchOption) {
        this.addCustomSizeValue(value);
      }
    });
  }
  emitChange() {
    this.$emit("change", this.getSelection(), this.getSizeType());
  }
  getSelection() {
    return cloneDeep(this.checkedSizes);
  }
  getSizeType() {
    return this.sizeType;
  }
}
